












import { Component, Mixins, Prop } from "vue-property-decorator";
import { Point, Color, LineStyle, LineKinds } from "../../domain/drawing";

@Component
export default class EraserIndicator extends Mixins() {
  @Prop()
  location: Point;

  @Prop({ default: () => new LineStyle(new Color("#FFFFFF"), LineKinds.Normal, 12) })
  lineStyle: LineStyle;

  get center(): Point {
    return new Point(this.radius, this.radius);
  }

  get diameter(): number {
    return this.lineStyle.width;
  }

  get radius(): number {
    return Math.max(this.diameter / 2, 0);
  }

  get locationStyle() {
    return {
      top: (this.location.y - this.radius) + "px",
      left: (this.location.x - this.radius) + "px",
    };
  }

  get eraserStyle() {
    return {
      fill: "#FFFFFF",
    };
  }
}
